import React from 'react';
import styles from './index.module.scss';

// Components
import { Link } from 'react-router-dom';
import { Card, Table } from 'react-bootstrap';
import StatusBadge from '../../../components/StatusBadge';

// functions
import dateToHumanReadable, { getUTCTime } from '../../../functions/hreadableDate';
// import timeDifference from '../../../functions/differenceDate';

const NoData = (props) => (
    <section className={styles.NoData}>
        No se encontro reparaciones.
    </section>
);

const RepairTable = (props) => (
    <Table striped bordered hover className={styles.Table}>
        <thead>
            <tr>
                <th>#</th>
                <th>Trabajo</th>
                {!props.minimal && <>
                    <th>Dispositivo</th>
                    <th>Cliente</th>
                    <th>Recibido</th>
                </>}
                <th>Estado</th>
            </tr>
        </thead>
        <tbody>
            {props.repairs.map(repair => (
                <tr>
                    <td>
                        <Link to={`/repairs/order/${repair._workId}`}>{repair._workId}</Link>
                    </td>
                    <td>{repair.service}</td>
                    {!props.minimal && <>
                        <td>{repair.device.name}</td>
                        <td>{repair.client.name}</td>
                        <td>{dateToHumanReadable(repair.timestamp, true, true)}</td>
                    </>}
                    <td className={styles.CenteredStatus}>
                        {(!props.minimal || repair.status !== 'ordered') && <StatusBadge status={repair.status} />}
                        {repair.status === 'ordered' && <StatusBadge className={styles.TimeBadge} status="time" time={getUTCTime(repair.deliveryDate, true, true)} />}
                    </td>
                </tr>
            ))}
        </tbody>
    </Table>
);

const RepairList = (props) => {
    return (
        <Card className={[styles.RepairList, props.className].join(" ")}>
            {props.repairs.length > 0 ? <RepairTable repairs={props.repairs} minimal={props.minimal} /> : <NoData />}
        </Card>
    );
};

export default RepairList;